import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { LoginFormData } from "../../models/userModel";
import { get } from "../../util/storage";
import AuthService from "../services/AuthService";

interface AuthState {
    token: string;
    isAuthenticated: boolean
}

const initialState: AuthState = {
    token: "",
    isAuthenticated: false
};



export const logout = createAsyncThunk("auth/logout", async () => {
    await AuthService.logout();
});

export const login = createAsyncThunk(
    "auth/login",
    async ({ email, password }: LoginFormData) => {

        const data = await AuthService.login({ email, password });
        return (await data);

    }
);

export const getInitialLoginValues = () => async (dispatch: (arg0: { payload: any; type: string; }) => void) => {
    const response = await Promise.all([
        get("token"),
        get("isAuthenticated"),]);
    const token = await response[0] || undefined;
    const isLoggedIn = await response[1] || false;
    const data = {
        token: token,
        isAuthenticated: isLoggedIn
    }
    dispatch(setInitialLoginValues(data));
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    // non-async reducers
    reducers: {
        setInitialLoginValues: (state, { payload }) => {
            state.isAuthenticated = payload.isAuthenticated;
            state.token = payload.token
        }
    },
    // async reducers here
    extraReducers: (builder) => {
        builder.addCase(login.fulfilled, (state, { payload }) => {
            state.isAuthenticated = true;
            state.token = payload;
        })
        builder.addCase(logout.fulfilled, (state) => {
            state.isAuthenticated = false;
            state.token = "";
        })
    },
});


export const { setInitialLoginValues } = authSlice.actions;
export default authSlice.reducer;